(function () {
    if (window.__lxCartInit) return;
    window.__lxCartInit = true;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function post(url, body) {
      return fetch(root + url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); });
    }


    function refresh() {
      return fetch(root + '?sections=mini-cart')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data['mini-cart'];
          var current = document.getElementById('mini-cart');
          if (html && current) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.getElementById('mini-cart');
            if (fresh) {
              var parts = ['.drawer__title', '.drawer__content', '.mini-cart__drawer-footer'];
              var canSwap = parts.every(function (s) { return fresh.querySelector(s) && current.querySelector(s); });
              if (canSwap) {
                parts.forEach(function (s) { current.querySelector(s).replaceWith(fresh.querySelector(s)); });
              } else {
                var overlay = current.querySelector('.drawer__overlay');
                current.innerHTML = fresh.innerHTML;
                if (!current.querySelector('.drawer__overlay') && overlay) current.prepend(overlay);
              }
            }
          }
          return fetch(root + 'cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.querySelectorAll('[data-cart-count], .header__cart-count').forEach(function (el) {
            el.textContent = cart.item_count;
          });
        });
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-lx-add]');
      if (!button) return;
      event.preventDefault();
      button.disabled = true;
      post('cart/add.js', { items: [{ id: Number(button.getAttribute('data-lx-add')), quantity: 1 }] })
        .then(refresh)
        .catch(function () { button.disabled = false; });
    });

    document.addEventListener('change', function (event) {
      var input = event.target.closest('[data-lx-protect]');
      if (!input) return;
      input.disabled = true;
      var request = input.checked
        ? post('cart/add.js', { items: [{ id: Number(input.getAttribute('data-lx-protect')), quantity: 1 }] })
        : post('cart/change.js', { id: input.getAttribute('data-lx-key'), quantity: 0 });
      request.then(refresh).catch(function () { input.disabled = false; input.checked = !input.checked; });
    });
  })();
